<!--
@component
RootLayout

Root layout. Tracks window size in appState and starts the data Poller.
-->

<script lang="ts">
  import { onMount } from 'svelte';
  import type { Snippet } from 'svelte';
  import { Poller, getData } from '$utils/data';
  import { appState } from '$lib/stores/index.svelte';
  import { page } from '$app/state';
  import { browser } from '$app/environment';
  import {
    fetchSTLF,
    reFetchUpdateSTLF,
    MetaAndHeaders,
  } from '$lib/components/ST/index.js';

  interface Props {
    children: Snippet;
  }

  let { children }: Props = $props();

  let innerWidth = $state(0);

  $effect(() => {
    appState.windowWidth = innerWidth;
  });

  let poller = $state<Poller | null>(null);

  // fetch st longform
  fetchSTLF();

  // `appState.optaData` is seeded by `+layout.ts` before this component
  // mounts. Here we only start the background `Poller` that refreshes it
  // on an interval (see src/utils/data/poller.js).
  $effect(() => {
    poller = new Poller((newData) => {
      appState.optaData = newData;
    });
    return () => poller?.destroy();
  });

  $effect(() => {
    const pageParams = browser && page?.url?.searchParams;
    appState.isLoading = !pageParams;
  });

  // Mirror SvelteKit's URL into the store so derived values (and the
  // few utils that need it during SSR) can read it without subscribing
  // to `page` themselves. Lives in the root layout so both the app and
  // embed groups get it.
  $effect(() => {
    appState.currentUrl = page.url ?? null;
  });

  onMount(() => {
    reFetchUpdateSTLF();
  });
</script>

<svelte:window bind:innerWidth />

{@render children()}

<MetaAndHeaders />
